
export default {
  props: {
    animate: {type: Boolean, default: false},
    stroke: {type: String, default: 'var(--gray-700)'}
  }
}
